<template>
  <HubContainer id="catalogsHub">

    <HubSection large icon="icon/hub/company.svg"
        :title="$t('catalogs_dashboard.company.title')"
        :description="$t('catalogs_dashboard.company.description')"
        :buttonAction="goToCompanyCatalogs">
    </HubSection>

    <HubSection large icon="icon/hub/organization.svg"
        :title="$t('catalogs_dashboard.global.title')"
        :description="$t('catalogs_dashboard.global.description')"
        :buttonAction="goToGlobalMenu">
    </HubSection>

  </HubContainer>
</template>

<script>
  import HubSection from "@/components/HubSection";
  import HubContainer from "@/components/HubContainer";

  export default {
    name: "CatalogsHub",

    components: { HubSection, HubContainer },

    mounted() {
      this.$store.state.pageTitleTranslationKey = "inventory.catalogs";
      this.$store.state.pageIcon = "/icon/menu.svg";
    },

    methods: {
      goToCompanyCatalogs() {
        this.$router.push(this.$router.buildContext("/catalog/company-catalogs", {branch: this.$route.query.branch}));
      },
      goToGlobalMenu() {
        this.$router.push(this.$router.buildContext("/catalogs", {branch: this.$route.query.branch}));
      }
    }
  }
</script>